/** True when the device has a usable link (transport up, or Wi-Fi on + navigator online). */
export function isDeviceNetworkConnected(input: {
  wifiEnabled?: boolean | null
  transportConnected?: boolean | null
  navigatorOnline: boolean
}): boolean {
  if (input.transportConnected === true) {
    return true
  }
  if (input.wifiEnabled === false) {
    return false
  }
  return input.navigatorOnline
}
